<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/edit?id=' + $route.query.member_id)" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="submitData">
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="9" md="10">
                  <b-form-select class="w-100" name="personal_trainer" v-validate="'required'" v-model="editData.personal_trainer_id">
                    <option :value="null">Please select</option>
                    <option v-for="listItem in itemPt" :key="listItem.id" :value="listItem.id">{{listItem.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('personal_trainer') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3" md="2">
                  <label>Running Session</label>
                </b-col>
                <b-col sm="9" md="10">
                  <flat-pickr :config="config" v-model="editData.created_at" name="date" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('date') }}</span>
                </b-col>
              </b-row>
              <div class="text-right mb-20">
                <button type="submit" class="btn-primary" :disabled="disabledBtnSubmit">Submit</button>
              </div>
              <div class="text-right mb-20">
                <template v-if="disabledBtnSubmit">
                  <span class="error">Member Session Expired!</span>
                </template>
              </div>
            </form>
            <hr>
            <div class="mb-40 mt-40">
              <div class="title font-300 font-20 mb-15">
                Running Session History
              </div>
              <table class="table border-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>PT Name</th>
                    <th>Transaction Type</th>
                    <th>Gross Amount</th>
                    <th>PT Session Price</th>
                    <th>Comission</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(itemData, index) in itemListEdit" :key="index">
                    <td>{{itemData.id}}</td>
                    <td>{{itemData.personal_training ? itemData.personal_training.name : ''}}</td>
                    <td>{{itemData.transaction_type ? itemData.transaction_type.name : ''}}</td>
                    <td>Rp. {{parseFloat(itemData.gross_amount).toLocaleString('id-ID', {maximumFractionDigits:2})}}</td>
                    <td>Rp. {{parseFloat(itemData.pt_session_price).toLocaleString('id-ID', {maximumFractionDigits:2})}}</td>
                    <td>Rp. {{parseFloat(itemData.personal_trainer_comission).toLocaleString('id-ID', {maximumFractionDigits:2})}}</td>
                    <td>{{parseDate(itemData.created_at)}}</td>
                    <td align="center">
                      <button class="btn btn-table warning btn-secondary mr-2" :disabled="itemData.is_closed === 1" @click="openPage('/memberEntry/editRunningSession?id=' + itemData.id + '&session_id=' + $route.query.id + '&member_id=' + $route.query.member_id)">Edit</button>
                      <button class="btn btn-table danger btn-secondary" :disabled="itemData.is_closed === 1" @click="deleteData(itemData.id)">Delete</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                  :total-pages="totalPage"
                  @page-changed="pageOneChanged"
                  prev-text="Prev" next-text="Next"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'addPtSession',
  components: {
    'app-pagination': Pagination
  },
  data: function () {
    return {
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      itemPt: [],
      itemPtSession: [],
      itemListEdit: [],
      editData: {
        personal_trainer_id: '',
        created_at: '',
        is_manual_running: 1
      },
      config: {
        altInput: true,
        altFormat: 'j F Y H:i',
        dateFormat: 'Y-m-d H:i',
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      },
      config2: {
        altInput: true,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d',
        enableTime: false
      },
      disabledBtnSubmit: false
    }
  },
  methods: {
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    parseDate(event) {
      return moment(event).format('DD MMMM YYYY')
    },
    submitData () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.post('fitness/v1/member_pt_session/update_running_session', this.editData).then(response => {
            this.fetchData()
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    deleteData (id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/member_pt_session/running_session?id='+id).then(response => {
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      var today = moment().format('YYYY-MM-DD')
      axios.get('fitness/v1/personal_training/').then(response => {
        this.itemPt = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/pt_session?sorting=name&sorting_type=asc').then(response => {
        this.itemPtSession = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/member_pt_session/' + this.$route.query.id).then(response => {
        var data = response.data.data

        const year = moment(data.expired_at).format('YYYY')
        const month = moment(data.expired_at).format('M')

        axios.get('crm/v1/closing_period/member_pt_session?year='+year+'&bulan='+month).then(response => {
          this.disabledBtnSubmit = true
        }).catch(error => {
          this.disabledBtnSubmit = false
          console.log('error', error)
        })

        this.editData.personal_trainer_id = response.data.data.personal_trainer_id
        // this.editData.created_at = response.data.data.created_at
        this.editData.created_at = moment().format('YYYY-MM-DD HH:mm')
        this.editData.member_pt_session_id = this.$route.query.id
        axios.get('fitness/v1/member_pt_session/running/' + response.data.data.trx_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&v=' + new Date()).then(response => {
          this.itemListEdit = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
        }).catch(error => {
          console.log('error', error)
        })
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
